import { Box } from "@mui/material";
import { setupManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { AllProducts, allProductsViews } from "../../../data/Axios/queries";
import ProductsForm from "./form";
// import { ProductColumns } from "../../../data/DynamicTable/Collumns";

const base_url = setupManagementUrl.uri;

const actions = {
  entity: "Products",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "productIds",
    inputObjectName: "bulkActivateDeactivateProducts",
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Inventory Details"
  },
};
const ignoreFields = ["id", "reorderPoint", "companyId", "uomId"];

// Define a column mapping for UI renaming
const columnMapping = {
  costPrice: "Buying Price",
  unitPrice: "Selling Price",
};

function ProductsTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Products"
        subtitle="Manage Products"
        columnMapping={columnMapping}
        FormComponent={ProductsForm}
        query={allProductsViews}
        base_url={base_url}
        actions={actions}
        ignoreFields={ignoreFields}
      />
    </Box>
  );
}

export default ProductsTable;
